/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';

// 页首部分
import Banner from './Banner';
import { BannerDataSource } from './data.source';

// 页尾部分
import Footer from '../layout/Footer';
import { FooterDataSource } from '../layout/data.source.js';

// 通用样式文件
import './less/antMotionStyle.less';

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  componentDidMount() {
    // 接口请求
  }

  render() {
    const children = [
      <Banner
        id="Banner"
        key="Banner"
        dataSource={BannerDataSource}
      />,
      <Footer 
        id="Footer"
        key="Footer"
        dataSource={FooterDataSource} 
      />
    ];
    
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {children}
      </div>
    );
  }
}
